export default __webpack_public_path__ + "_/images/app/telegram/telegram-en-2-963faa90a790e59399ee1e5988f59fb2b5a52736731c175c44318fe7a9880fd1.jpg";